
import { useStore } from '@/store'
import { defineComponent, onMounted, ref } from 'vue'
import { computed, watch } from 'vue'
import nameSettings from '@/settings/name-settings.json'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import MobileAnimationService from '@/services/form/mobile-animation.service'
import NameConverterService from '@/services/form/name-converter.service'
import settings from '@/settings/settings.json'
import Analytics from '@/singletons/analytics'

export default defineComponent({
  name: 'NameCharForm',
  setup() {
    const store = useStore()
    const configNonameId = computed(() => store.getters.configNonameId)
    const configNamechar = computed(() => store.getters.configNamechar)
    let namePreviews = ref()
    let hasSubmitted = ref()
    const root = ref(null)
    let mobileAnimationService = new MobileAnimationService()
    let nameConverterService = new NameConverterService()
    let nameTextError = ref('')
    let nameTextInput = ref('')
    let valid = false

    // prettier-ignore
    watch(() => configNamechar.value, (name) => {
        if(!nameTextInput.value || (nameTextInput.value! as string).length <= 0) {
          nameTextInput.value = name ?? ''
        }
        setNamePreviews(name ?? '')
      }
    )

    // prettier-ignore
    watch(() => root.value, (_) => {
        if(configNamechar.value) {
          nameTextInput.value = configNamechar.value
        }
        setNamePreviews(configNamechar.value ?? '')
      }
    )

    const onSubmit = () => {
      hasSubmitted.value = true
      valid = validate(nameTextInput.value)
      if (!valid) {
        return
      }
      const val = nameTextInput.value ? (nameTextInput.value! as string) : ''
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NAMECHAR, val)
      Analytics.instance.sendNamecharEvent(val)
    }

    function validate(value: string): boolean {
      if (!value) {
        nameTextError.value = 'お名前を入力してください'
        return false
      }
      if (value.length > 12) {
        nameTextError.value = 'お名前は12文字以内で入力してください'
        return false
      }
      const pattern = '^[' + settings.allowedChars.replace(/-/g, '\\-') + ']+$'
      if (!new RegExp(pattern).test(value)) {
        nameTextError.value = 'ひらがな、アルファベット（大文字のみ）、記号（上記7種）、ハイフン、ピリオド、中黒、スペースが入れられます'
        return false
      }
      nameTextError.value = ''
      return true
    }

    function setNamePreviews(value: string) {
      const converted = nameConverterService.convertToHTMLCharacters(value)
      let previews = [] as string[]
      for (let i = 0; i < 12; i++) {
        const val = converted.charAt(i)
        previews.push(val ?? '')
      }
      namePreviews.value = previews
    }

    const isValid = () => {
      return valid
    }

    return {
      configNonameId,
      configNamechar,
      nameSettings,
      onSubmit,
      root,
      namePreviews,
      nameTextInput,
      nameTextError,
      hasSubmitted,
      isValid
    }
  }
})
